module.exports = __webpack_public_path__ + "img/camp03_actived.1e5ce028.png";